<style>
	/* These classes are only needed because the
      drawer is in a container on the page. */
	.drawer-container {
		position: relative;
		display: flex;
		height: 650px;
		overflow: hidden;
		z-index: 0;
	}

	:global(.app-content) {
		flex: auto;
		overflow: auto;
		position: relative;
		flex-grow: 1;
	}

	.main-content {
		overflow: auto;
		padding: 16px;
		height: 100%;
		box-sizing: border-box;
	}

	:global(.mdc-drawer .mdc-deprecated-list-item--activated) {
		color: black;
	}

	:global(.smui-accordion__header__title) {
		flex-basis: 0px;
	}
</style>

<script lang="ts">
	import Accordion, { Content, Header, Panel } from '@smui-extra/accordion';
	import Drawer, { AppContent, Subtitle, Title } from '@smui/drawer';
	import IconButton, { Icon } from '@smui/icon-button';
	import List, { Item, Text } from '@smui/list';
	import { afterUpdate, onMount } from 'svelte';
	import { _ } from 'svelte-i18n';
	import { writable } from 'svelte/store';
	import DrawerLoading from '../../../../../../shared/components/common/Loading/DrawerLoading.svelte';
	import ConfirmModal from '../../../../../../shared/components/common/Modal/ConfirmModal.svelte';
	import CategoriaMisuraPunteggioPosizione from '../../../../../../shared/models/PSCL/Misura/CategoriaMisuraPunteggioPosizione';
	import PSCLMisura from './PSCLMisuraEdit.svelte';
	import PSCLMisuraEntry from './PSCLMisuraEntry.svelte';

	export let sedi = [];
	export let data = [];

	let [dataCategorieMisuraPunteggioPosizione, loadingCategorieMisuraPunteggioPosizione, errorCategorieMisuraPunteggioPosizione] = [
		writable(null),
		writable(true),
		null,
	];

	let componentLoadedWithData = false;
	let categorieDrawer = true;
	let prevActiveIndex = 0;
	let activeIndex = 0;
	let initialized = false;

	let pannelloInserimentoMisura = data.length > 0 ? false : true;

	let openConfirmDeletePsclMisuraDialog: boolean = false;
	let psclMisuraIndexToDelete: number = null;
	let tipoMisuraEntrySelected: number = null;
	let tipiMisuraSelected: number[] = [];

	function initializeMisure() {
        if (data.length > 0) {
            data[activeIndex].psclMisure.forEach((psclMisura) => {
                psclMisura.pannello = false;
            });
            $loadingCategorieMisuraPunteggioPosizione = false;
            data = data.sort((a, b) => {
                if (a.descrizione === "Altre iniziative collaterali") return 1;
                if (b.descrizione === "Altre iniziative collaterali") return -1;
                if (b.punteggio !== a.punteggio) {
                    return b.punteggio - a.punteggio;
                }
                return a.id - b.id;
            });
        }
    }

	onMount(() => {
        initializeMisure();
        initialized = true;
    });

	afterUpdate(() => {
		if (prevActiveIndex !== activeIndex || !componentLoadedWithData) {
			prevActiveIndex = activeIndex;
			if (data.length > 0) {
				initializeMisure();
			} else {
				if (sedi.length === 1) {
					// Se c'è solo una sede, usiamo getListByLocation
					[dataCategorieMisuraPunteggioPosizione, loadingCategorieMisuraPunteggioPosizione, errorCategorieMisuraPunteggioPosizione] =
						CategoriaMisuraPunteggioPosizione.getListByLocation(sedi[0].id.toString());
				} else if (sedi.length > 1) {
					// Se ci sono più sedi, usiamo un nuovo metodo per ottenere le categorie comuni
					[dataCategorieMisuraPunteggioPosizione, loadingCategorieMisuraPunteggioPosizione, errorCategorieMisuraPunteggioPosizione] =
						CategoriaMisuraPunteggioPosizione.getListForMultipleSedi(sedi.map(sede => sede.id));
				} else {
					// Se non ci sono sedi selezionate, impostiamo i dati come vuoti
					dataCategorieMisuraPunteggioPosizione.set([]);
					loadingCategorieMisuraPunteggioPosizione.set(false);
					errorCategorieMisuraPunteggioPosizione.set(null);
				}

				dataCategorieMisuraPunteggioPosizione.subscribe((value) => {
					if (value) {
						let categorie = sedi.length === 1 ? value : value.response;
						
						if (categorie && categorie.length > 0) {
							categorie.forEach((categoriaMisuraPunteggioPosizione) => {
								categoriaMisuraPunteggioPosizione.psclMisure = [];
							});
							data[activeIndex] = categorie[0];
							data = [...categorie].sort((a, b) => {
								// Mantieni "Altre iniziative collaterali" sempre in fondo
								if (a.descrizione === 'Altre iniziative collaterali') return 1;
								if (b.descrizione === 'Altre iniziative collaterali') return -1;

								// Ordinamento primario per punteggio
								if (b.punteggio !== a.punteggio) {
									return b.punteggio - a.punteggio;
								}

								// Ordinamento secondario per id (o un altro campo univoco) in caso di punteggio uguale
								return a.id - b.id;
							});
						}
					}
				});
			}
			componentLoadedWithData = true;
		}
	});

	$: if (data) {
		for (let i = 0; i < data.length; i++) {
			data[i].punteggioIntPart = data[i].punteggio ? data[i].punteggio.toString().split('.')[0] : '';
			data[i].punteggioDecimalPart = data[i].punteggio ? data[i].punteggio.toString().split('.')[1] : data[i].punteggio;
			data[i].width = data[i].posizione < 10 ? (10 - data[i].posizione + 1) * 10 + '%' : '50%';
			data[i].backgroundColor = i == data.length - 1 || i == data.length - 1 ? 'gold' : 'rgb(106, 180, 45)';
		}
	}

	function handleAddPsclMisura(event) {
		event.detail.pannello = false;
		data[activeIndex].psclMisure.unshift(structuredClone(event.detail));
		data[activeIndex].psclMisure = data[activeIndex].psclMisure;
	}

	function deletePsclMisura(index) {
		if (data[activeIndex].psclMisure[index]?.tipoMisuraId) {
			const indexTipoMisura = tipiMisuraSelected.indexOf(data[activeIndex].psclMisure[index]?.tipoMisuraId);
			if (indexTipoMisura > -1) {
				tipiMisuraSelected = tipiMisuraSelected.splice(indexTipoMisura, 1);
			}
		}
		data[activeIndex].psclMisure.splice(index, 1);
	}

	$: if (data[activeIndex]?.psclMisure) {
		tipiMisuraSelected = data[activeIndex].psclMisure.map((item) => item.tipoMisuraId);
		if (tipoMisuraEntrySelected && !tipiMisuraSelected.includes(tipoMisuraEntrySelected)) {
			tipiMisuraSelected.push(tipoMisuraEntrySelected);
		}
	}
</script>

<ConfirmModal bind:showModal="{openConfirmDeletePsclMisuraDialog}" onConfirm="{() => deletePsclMisura(psclMisuraIndexToDelete)}" />
{#if $loadingCategorieMisuraPunteggioPosizione}
	<DrawerLoading />
{:else}
	<div class="drawer-container">
		<Drawer variant="dismissible" bind:open="{categorieDrawer}">
			<Header>
				<Title>{$_('page.pscl.detail.categories')}</Title>
				<Subtitle>{$_('page.pscl.detail.measure_categories')}</Subtitle>
			</Header>
			<Content>
				<List>
					{#if data && data.length > 0}
						{#each data as categoriaMisura, i}
							<Item href="javascript:void(0)" on:click="{() => (activeIndex = i)}" activated="{activeIndex === i}">
								<div class="w-full">
									<Text>{categoriaMisura.descrizione}</Text>
									<div
										class="text-center"
										style="background-color: {categoriaMisura.backgroundColor}; max-width: 100%; width: {categoriaMisura.width}"
										title="{categoriaMisura.punteggioIntPart}{categoriaMisura.punteggioDecimalPart
											? `.${categoriaMisura.punteggioDecimalPart.toString().substring(0, 2)}`
											: ''}"
									>
										<span>&nbsp;</span>
									</div>
								</div>
							</Item>
						{/each}
					{/if}
				</List>
			</Content>
		</Drawer>
		<AppContent class="app-content">
			<main class="main-content">
				<button
					on:click="{() => (categorieDrawer = !categorieDrawer)}"
					class="ml-1.5 mt-1.5 w-8 rounded-md bg-transparent p-2 focus:bg-transparent"
				>
					<svg
						class="h-4 w-4 text-gray-600 {categorieDrawer
							? '-rotate-180 transform transition-transform'
							: '0 transform transition-transform'}"
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor"
					>
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7"></path>
					</svg>
				</button>
				<br />
				<span class="status">{data?.[activeIndex]?.descrizione}</span>
				<span class="status">{data?.[activeIndex]?.descrizione}</span>
				{#if data?.[activeIndex]?.psclMisure?.length > 0}
					{@const misureNuove = data[activeIndex].psclMisure.filter(m => !m.id || m.id === 0)}
					{@const misureEsistenti = data[activeIndex].psclMisure.filter(m => m.id && m.id > 0)}
					
					{#if misureNuove.length > 0}
						<div class="pt-4 pb-3">
							{#each misureNuove as psclMisura, i}
								{#if psclMisura.pannello != null && psclMisura.pannello != undefined}
									<Accordion>
										<Panel square variant="outlined" color="primary" extend bind:open="{psclMisura.pannello}">
											<Header>
												{psclMisura.nome}
												<IconButton
													slot="icon"
													on:click="{() => {
														psclMisuraIndexToDelete = data[activeIndex].psclMisure.indexOf(psclMisura);
														openConfirmDeletePsclMisuraDialog = true;
													}}"
												>
													<Icon class="material-icons">delete</Icon>
												</IconButton>
											</Header>
											<Content>
												<PSCLMisura
													bind:data="{psclMisura}"
													bind:psclCategoriaId="{data[activeIndex].categoriaId}"
													bind:tipiMisuraSelected="{tipiMisuraSelected}"
												/>
											</Content>
										</Panel>
									</Accordion>
								{/if}
							{/each}
						</div>
					{/if}
				{/if}
				<Accordion>
					<Panel square variant="outlined" color="primary" extend bind:open="{pannelloInserimentoMisura}">
						<Header>
							{$_('page.pscl.detail.new_measure')}
							<IconButton slot="icon" toggle pressed="{pannelloInserimentoMisura}">
								<Icon class="material-icons" on>unfold_less</Icon>
								<Icon class="material-icons">unfold_more</Icon>
							</IconButton>
						</Header>
						<Content>
							<PSCLMisuraEntry
								bind:psclCategoriaId="{data[activeIndex].categoriaId}"
								on:psclMisura="{handleAddPsclMisura}"
								bind:tipoMisuraEntrySelected="{tipoMisuraEntrySelected}"
								bind:tipiMisuraSelected="{tipiMisuraSelected}"
							/>
						</Content>
					</Panel>
				</Accordion>
				{#if data?.[activeIndex]?.psclMisure?.length > 0}
					{@const misureEsistenti = data[activeIndex].psclMisure.filter(m => m.id && m.id > 0)}
					
					{#if misureEsistenti.length > 0}
						<div class="pt-4 pb-3">
							{#each misureEsistenti as psclMisura, i}
								{#if psclMisura.pannello != null && psclMisura.pannello != undefined}
									<Accordion>
										<Panel square variant="outlined" color="primary" extend bind:open="{psclMisura.pannello}">
											<Header>
												{psclMisura.nome}
												<IconButton
													slot="icon"
													on:click="{() => {
														psclMisuraIndexToDelete = data[activeIndex].psclMisure.indexOf(psclMisura);
														openConfirmDeletePsclMisuraDialog = true;
													}}"
												>
													<Icon class="material-icons">delete</Icon>
												</IconButton>
											</Header>
											<Content>
												<PSCLMisura
													bind:data="{psclMisura}"
													bind:psclCategoriaId="{data[activeIndex].categoriaId}"
													bind:tipiMisuraSelected="{tipiMisuraSelected}"
												/>
											</Content>
										</Panel>
									</Accordion>
								{/if}
							{/each}
						</div>
					{/if}
				{/if}
			</main>
		</AppContent>
	</div>
{/if}